"use strict";

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_state_1 = require("prosemirror-state");

var getMarkRange_1 = __importDefault(require("../queries/getMarkRange"));

var Mark_1 = __importDefault(require("./Mark"));

var Placeholder = /*#__PURE__*/function (_Mark_1$default) {
  _inherits(Placeholder, _Mark_1$default);

  var _super = _createSuper(Placeholder);

  function Placeholder() {
    _classCallCheck(this, Placeholder);

    return _super.apply(this, arguments);
  }

  _createClass(Placeholder, [{
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        mark: "placeholder"
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "placeholder";
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        parseDOM: [{
          tag: "span.template-placeholder"
        }],
        toDOM: function toDOM() {
          return ["span", {
            class: "template-placeholder"
          }];
        }
      };
    }
  }, {
    key: "toMarkdown",
    get: function get() {
      return {
        open: "!!",
        close: "!!",
        mixable: true,
        expelEnclosingWhitespace: true
      };
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this = this;

      return [new prosemirror_state_1.Plugin({
        props: {
          handleTextInput: function handleTextInput(view, from, to, text) {
            if (_this.editor.props.template) {
              return false;
            }

            var state = view.state,
                dispatch = view.dispatch;
            var $from = state.doc.resolve(from);
            var range = getMarkRange_1.default($from, state.schema.marks.placeholder);
            if (!range) return false;
            var selectionStart = Math.min(from, range.from);
            var selectionEnd = Math.max(to, range.to);
            dispatch(state.tr.removeMark(range.from, range.to, state.schema.marks.placeholder).insertText(text, selectionStart, selectionEnd));
            var $to = view.state.doc.resolve(selectionStart + text.length);
            dispatch(view.state.tr.setSelection(prosemirror_state_1.TextSelection.near($to)));
            return true;
          },
          handleKeyDown: function handleKeyDown(view, event) {
            if (!view.props.editable || !view.props.editable(view.state)) {
              return false;
            }

            if (_this.editor.props.template) {
              return false;
            }

            if (event.key !== "ArrowLeft" && event.key !== "ArrowRight" && event.key !== "Backspace") {
              return false;
            }

            var state = view.state,
                dispatch = view.dispatch;

            if (event.key === "Backspace") {
              var range = getMarkRange_1.default(state.doc.resolve(Math.max(0, state.selection.from - 1)), state.schema.marks.placeholder);
              if (!range) return false;
              dispatch(state.tr.removeMark(range.from, range.to, state.schema.marks.placeholder).insertText("", range.from, range.to));
              return true;
            }

            if (event.key === "ArrowLeft") {
              var _range = getMarkRange_1.default(state.doc.resolve(Math.max(0, state.selection.from - 1)), state.schema.marks.placeholder);

              if (!_range) return false;
              var startOfMark = state.doc.resolve(_range.from);
              dispatch(state.tr.setSelection(prosemirror_state_1.TextSelection.near(startOfMark)));
              return true;
            }

            if (event.key === "ArrowRight") {
              var _range2 = getMarkRange_1.default(state.selection.$from, state.schema.marks.placeholder);

              if (!_range2) return false;
              var endOfMark = state.doc.resolve(_range2.to);
              dispatch(state.tr.setSelection(prosemirror_state_1.TextSelection.near(endOfMark)));
              return true;
            }

            return false;
          },
          handleClick: function handleClick(view, pos, event) {
            if (!view.props.editable || !view.props.editable(view.state)) {
              return false;
            }

            if (_this.editor.props.template) {
              return false;
            }

            if (event.target instanceof HTMLSpanElement && event.target.className.includes("template-placeholder")) {
              var state = view.state,
                  dispatch = view.dispatch;
              var range = getMarkRange_1.default(state.selection.$from, state.schema.marks.placeholder);
              if (!range) return false;
              event.stopPropagation();
              event.preventDefault();
              var startOfMark = state.doc.resolve(range.from);
              dispatch(state.tr.setSelection(prosemirror_state_1.TextSelection.near(startOfMark)));
              return true;
            }

            return false;
          }
        }
      })];
    }
  }]);

  return Placeholder;
}(Mark_1.default);

exports.default = Placeholder;